export default {
  label: 'CPF',
  hint: 'Pankkisi tarvitsee CPF-tunnuksesi tätä maksua varten. Välitämme sen eteenpäin emmekä säilytä sitä.',
  invalid: 'Tämä ei ole kelvollinen CPF. Tarkista 11 numeroa.',
};
